import { eUSAState } from 'ui-toolkit/enums/states';
import { eInternalTransferCategory } from '../../../types/accounting/response/eInternalTransferCategory';

const specialStates: string[] = [eUSAState.NV, eUSAState.AZ, eUSAState.TX, eUSAState.WA];
const categoriesToDisable: eInternalTransferCategory[] = [
  eInternalTransferCategory.holdback,
  eInternalTransferCategory.other,
  eInternalTransferCategory.property_taxes,
  eInternalTransferCategory.CorrectingTransfer,
];

export const getDisabledLegacyInternalTransferCategories = (state: string | null): eInternalTransferCategory[] => {
  if (state == null || !specialStates.includes(state)) {
    return categoriesToDisable;
  }
  return [eInternalTransferCategory.CorrectingTransfer];
};
